import SoundFile from "../../types/SoundFile"

/*
 * Download a sound file to the user's disk.
 *
 * The fileUrl is a cross-origin signed URL, so the anchor `download`
 * attribute is ignored by browsers. We fetch the file as a blob and save it
 * via an object URL instead, which forces a download with the original
 * filename. If the fetch fails (e.g. CORS), we fall back to opening the URL
 * in a new tab.
 */
export default async function downloadSoundFile(
  soundFile: SoundFile,
): Promise<void> {
  if (!soundFile.fileUrl) return

  const filename = soundFile.filename || soundFile.name || "sound"

  try {
    const response = await fetch(soundFile.fileUrl)
    if (!response.ok) throw new Error(`Unexpected response ${response.status}`)
    const blob = await response.blob()

    const objectUrl = URL.createObjectURL(blob)
    const anchor = document.createElement("a")
    anchor.href = objectUrl
    anchor.download = filename
    document.body.appendChild(anchor)
    anchor.click()
    anchor.remove()
    URL.revokeObjectURL(objectUrl)
  } catch (err) {
    console.error("Failed to download sound file, opening in new tab", err)
    window.open(soundFile.fileUrl, "_blank", "noreferrer")
  }
}
